import React from "react";
import {Brands} from "@core-ui/utility";
import {ResponsiveIcon} from "../components/Icon";
import {IconContainerProps} from "../types";

const CrossBrandLargeViewBoxSVG = (
  <svg xmlns="http://www.w3.org/2000/svg">
    <path
      clipRule="evenodd"
      d="M14 8C8.477 8 4 12.477 4 18s4.477 10 10 10 10-4.477 10-10S19.523 8 14 8ZM0 18C0 10.268 6.268 4 14 4s14 6.268 14 14-6.268 14-14 14S0 25.732 0 18Z"
      fillRule="evenodd"
    />
    <path d="m16.493 11.128 2.61 1.48-4.44 7.83-2.61-1.48zM20 0v3H8V0z" />
  </svg>
);

const CrossBrandSmallViewBoxSVG = (
  <svg xmlns="http://www.w3.org/2000/svg">
    <path
      clipRule="evenodd"
      d="M7 4a5 5 0 1 0 0 10A5 5 0 0 0 7 4ZM0 9a7 7 0 1 1 14 0A7 7 0 0 1 0 9Z"
      fillRule="evenodd"
    />
    <path d="m8.246 5.564 1.305.74-2.22 3.915-1.305-.74zM10 0v1.5H4V0z" />
  </svg>
);

const brandIconLargeViewBoxSVGs = {
  [Brands.Athleta]: CrossBrandLargeViewBoxSVG,
  [Brands.BananaRepublic]: CrossBrandLargeViewBoxSVG,
  [Brands.BananaRepublicFactoryStore]: CrossBrandLargeViewBoxSVG,
  [Brands.Gap]: CrossBrandLargeViewBoxSVG,
  [Brands.GapFactoryStore]: CrossBrandLargeViewBoxSVG,
  [Brands.OldNavy]: CrossBrandLargeViewBoxSVG,
  crossBrand: CrossBrandLargeViewBoxSVG,
};

const brandIconSmallViewBoxSVGs = {
  [Brands.Athleta]: CrossBrandSmallViewBoxSVG,
  [Brands.BananaRepublic]: CrossBrandSmallViewBoxSVG,
  [Brands.BananaRepublicFactoryStore]: CrossBrandSmallViewBoxSVG,
  [Brands.Gap]: CrossBrandSmallViewBoxSVG,
  [Brands.GapFactoryStore]: CrossBrandSmallViewBoxSVG,
  [Brands.OldNavy]: CrossBrandSmallViewBoxSVG,
  crossBrand: CrossBrandSmallViewBoxSVG,
};

export const TimerIcon = (props: IconContainerProps): JSX.Element => (
  <ResponsiveIcon
    {...props}
    brandIconLargeViewBoxSVGs={brandIconLargeViewBoxSVGs}
    brandIconSmallViewBoxSVGs={brandIconSmallViewBoxSVGs}
  />
);
